export const isCustomizableMadePage = () => window.location.pathname.includes("custom-printed-");

export const isCustomizablePlp = () => window.location.href.includes("customizable");

export const isFlashPdp = () => window.location.href.includes("sameday=true");

export const isMadeSamplePdp = () => {
  // Check if it's a made dedicated PDP with sample parameter
  const url = window.location.href;
  const { pathname } = window.location;
  const isMadePdp = pathname.includes("/custom-printed-") || pathname.endsWith(".html");
  const hasSampleParam = url.includes("sample=true");
  return isMadePdp && hasSampleParam;
};

export const getMadeProductType = isSample => {
  const isActuallySample = typeof isSample === "boolean" ? isSample : isMadeSamplePdp();
  return isActuallySample ? "made_sample_pdp" : "made_pdp";
};

export default {};
